import { render, staticRenderFns } from "./ViewFrame.vue?vue&type=template&id=4e5311cf"
import script from "./ViewFrame.ts?vue&type=script&lang=ts&external"
export * from "./ViewFrame.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports